import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const ResetIcon = memo(() => (
    <IconWrapper>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M11 19.6q-2.475-.35-4.088-2.225T5.3 13q0-1.325.525-2.538T7.25 8.3l.5.5a5.35 5.35 0 0 0-1.313 1.912A6.1 6.1 0 0 0 6 13q0 2.2 1.412 3.862Q8.825 18.525 11 18.9zm2 .05v-.7q2.15-.5 3.575-2.138T18 13q0-2.5-1.75-4.25T12 7h-.8l1.75 1.75-.5.5-2.6-2.6 2.6-2.6.5.5L11.2 6.3h.8q2.8 0 4.75 1.95T18.7 13q0 2.499-1.625 4.35T13 19.65"
            />
        </svg>
    </IconWrapper>
));
